import React from 'react';
import PassConfirmationForm from './PassConfirmationForm';
import DemoAuthTemplate from '../../common/auth-template/AuthTemplate';

const PassConfirmation = () => {
  return (
    <DemoAuthTemplate>
      {/*<ClerkLogIn />*/}
      <PassConfirmationForm />
    </DemoAuthTemplate>
  );
};

export default PassConfirmation;
